<template>
  <CFooter>
    <div>
      Grupo Dar
      <span class="ms-1"
        >&copy; {{ new Date().getFullYear() }}.</span
      >
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>
